document.addEventListener("DOMContentLoaded", function () {
  var enquiryButton = document.getElementById("enquiry-button");
  var enquiryModal = document.getElementById("enquiry-modal");
  var closeEnquiry = document.querySelector(".enquiry-close");
  var enquiryModalContent = document.querySelector(
    "#enquiry-modal .enquiry-modal-content"
  );

  var successMessage = document.querySelector("[data-enquiry-success-message]");
  var enquiryButton = document.getElementById("enquiry-button");
  var successContainer = document.getElementById("enquiry-success-message-container");

  if (successMessage) {
    successContainer.appendChild(successMessage);
  }

  var errorMessage = document.querySelector("[data-enquiry-error-message]");
  var enquiryButton = document.getElementById("enquiry-button");
  var errorContainer = document.getElementById("enquiry-error-message-container");

  if (errorMessage) {
    errorContainer.appendChild(errorMessage);
  }

  enquiryButton.addEventListener("click", function () {
    enquiryModal.style.display = "flex";
    document.body.style.overflow = "hidden";
  });

  closeEnquiry.addEventListener("click", function () {
    enquiryModal.style.display = "none";
    document.body.style.overflow = "";
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && enquiryModal.style.display === "flex") {
      enquiryModal.style.display = "none";
      document.body.style.overflow = "";
    }
  });

  document.addEventListener("click", function (event) {
    if (
      enquiryModal.style.display === "flex" &&
      !enquiryModalContent.contains(event.target) &&
      !enquiryButton.contains(event.target)
    ) {
      enquiryModal.style.display = "none";
      document.body.style.overflow = "";
    }
  });
});
